import * as Constants from './Constants';

const initialState = {
  validatedCreditHold: false,
  creditStatusLanded: false,
  reSubmitSuccessFlag: false,
  isCreditOnHold: false,
  creditHoldSessionData: {},
  creditShowError: false,
  creditStatusNfyMsg: '',
};

function creditStatus(state = initialState, action) {
  switch (action.type) {
    case Constants.VALIDATED_HOLD_ORDER:
      return { ...state, validatedCreditHold: action.response };
    case Constants.RUN_CREDIT_REVIEW_SUCCESS: {
      return { ...state, creditReviewSuccess: action.response };
    }
    case Constants.RUN_CREDIT_REVIEW_SUCCESS_DATA:
      return { ...state, creditReviewSuccessData: action.response };
    case 'RUN_CREDIT_REVIEW_SUCCESS_RESPONSE_STATUS': {
      const previousState = state.reSubmitSuccessFlag;
      return { ...state, creditReviewSuccessResponse: action.response, reSubmitSuccessFlag: !previousState };
    }
    case Constants.CREDIT_STATUS_LANDED:
      return { ...state, creditStatusLanded: action.response };
    case Constants.RESUBMIT_CREDIT_FAILED:
      return { ...state, creditCheckFail: action.response };
    case Constants.CREDIT_HOLD_STATUS:
      return { ...state, creditCheckSession: action.data };
    case Constants.CEF_CREDIT_STATUS_ERROR:
      return { ...state, creditShowError: action.response, creditStatusNfyMsg: action.errorMessage };
    default:
      return state;
  }
}

export default creditStatus;
